"use client"

import Image from "next/image"
import { HOME_IMAGES } from "@/lib/home-images"
import { scrollToSection } from "@/lib/scroll-to-section"
import { CyberGrid } from "@/components/ui/cyber-grid"

export function Hero() {
  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-[#050508] via-[#0A0A0F] to-[#0F0F1A] pt-20"
      style={{ contain: "layout style paint" }}
    >
      <CyberGrid />

      <div className="absolute inset-0 bg-gradient-to-t from-[#050508] via-transparent to-transparent z-10" />

      <div className="absolute inset-0 opacity-10 z-0">
        <Image
          src={HOME_IMAGES.heroBackground}
          alt="Fundo tecnológico escuro"
          fill
          className="object-cover"
          sizes="100vw"
          quality={40}
          priority
          loading="eager"
        />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center w-full">
        <div className="space-y-6 animate-fade-in">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black font-[family-name:var(--font-orbitron)] text-white leading-tight tracking-tight animate-glitch-loop">
            Conecte-se com o{" "}
            <span className="bg-gradient-to-r from-[#B829FF] via-[#00A3FF] to-[#FFEA00] bg-clip-text text-transparent">
              Melhor da Tecnologia
            </span>
          </h1>

          <p className="text-xl text-slate-100 max-w-xl leading-relaxed font-medium">
            A ponte entre você e seu novo smartphone ou console. Vendas, acessórios e assistência técnica de alta performance.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 pt-4">
            <button
              type="button"
              onClick={() => scrollToSection("products")}
              className="group relative px-8 py-4 bg-gradient-to-r from-[#B829FF] to-[#00A3FF] text-white rounded-xl font-bold font-[family-name:var(--font-orbitron)] tracking-wide hover:scale-105 transition-transform duration-300 overflow-hidden neon-box-purple"
            >
              <span className="relative z-10">Ver Produtos</span>
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
            </button>
            <button
              type="button"
              onClick={() => scrollToSection("services")}
              className="px-8 py-4 border-2 border-[#00F0FF] text-[#00F0FF] rounded-xl font-bold font-[family-name:var(--font-orbitron)] tracking-wide hover:bg-[#00F0FF]/10 transition-colors duration-300"
            >
              Agendar Reparo
            </button>
          </div>
        </div>

        <div className="relative w-full block mt-8 md:mt-0">
          <div className="relative w-full aspect-square max-w-sm md:max-w-lg mx-auto">
            <div 
              className="absolute inset-0 bg-gradient-to-br from-[#B829FF]/30 via-[#00A3FF]/20 to-[#00F0FF]/30 rounded-full blur-3xl animate-neon-glow"
              style={{ willChange: "opacity" }}
            />
            <div className="relative w-full h-full rounded-2xl overflow-hidden border border-[#B829FF]/30 neon-box-purple">
              <Image
                src={HOME_IMAGES.heroMain}
                alt="Tecnologia de ponta"
                fill
                className="object-cover"
                sizes="(max-width: 768px) 100vw, 50vw"
                quality={60}
                priority
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050508]/80 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
